var map = {
	"./ar.svg": 36700,
	"./bo.svg": 53035,
	"./br.svg": 46097,
	"./cl.svg": 81253,
	"./co.svg": 18650,
	"./cr.svg": 22022,
	"./ec.svg": 4262,
	"./mx.svg": 84994,
	"./pe.svg": 73638,
	"./us.svg": 35117,
	"./uy.svg": 19436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94983;